import { createSlice } from '@reduxjs/toolkit';

import { STATUS } from '@constants/status';

export const initialState = {
  model: {
    results: [],
  },
  meta: {
    errorMessage: '',
    itemLoading: [],
    status: STATUS.LOADING,
  },
};

const dataFormats = createSlice({
  name: 'dataFormats',
  initialState,
  reducers: {
    reset: () => initialState,
    request: state => {
      state.meta.errorMessage = '';
      state.meta.status = STATUS.LOADING;
    },
    success: (state, action) => {
      state.meta.status = STATUS.SUCCESS;
      state.model.results = action.payload.result;
    },
    failure: (state, action) => {
      state.meta.status = STATUS.ERROR;
      state.meta.errorMessage = action.payload.errorMessage;
    },
    updateRequest: (state, action) => {
      state.meta.itemLoading = [...state.meta.itemLoading, action.payload.entityJurisdictionId];
    },
    updateSuccess: (state, action) => {
      state.meta.itemLoading = state.meta.itemLoading.filter(
        entityJurisdictionId => entityJurisdictionId !== action.payload.result.entityJurisdiction
      );
      const newResult = state.model.results.map(dataFormat => {
        const { entityJurisdiction, ...update } = action.payload.result;
        if (dataFormat.entityJurisdictionId === entityJurisdiction) {
          return {
            ...dataFormat,
            ...update,
          };
        }

        return dataFormat;
      });
      state.model.results = newResult;
    },
    updateFailure: (state, action) => {
      state.meta.itemLoading = state.meta.itemLoading.filter(
        entityJurisdictionId =>
          entityJurisdictionId !== action.payload.requestPayload.entityJurisdictionId
      );
    },
  },
});

export const {
  reset: dataFormatsReset,
  request: dataFormatsRequest,
  success: dataFormatsSuccess,
  failure: dataFormatsFailure,
  updateRequest: dataFormatsUpdateRequest,
  updateSuccess: dataFormatsUpdateSuccess,
  updateFailure: dataFormatsUpdateFailure,
} = dataFormats.actions;

export default dataFormats.reducer;
